<template>
  <div class="accordianOpen rooms-pricing-details rooms-pricing-details--rooms-listing">
    <div class="rooms-pricing-details__container push-v--desktop--x-small">
      <div class="rooms-pricing-details__block">
        <h3
            class="rooms-pricing-details__title text-center--desktop text-center--tablet text-center--mobile push-v--tablet--x-small push-v--mobile--x-small"
        >
          {{ title }}
        </h3>
        <div v-if="longStayPriceText && (bookingType==='longStay' && longStayPrices.length)" class="rooms-pricing-details__price-free-text" v-html="longStayPriceText" />
        <div v-if="!longStayPriceText && (bookingType==='longStay' && longStayPrices.length)" class="rooms-pricing-details__price-free-text">
          &pound;{{ longStayPrices[0] ? longStayPrices[0].pricePerWeek : "" }} per week
          /
          {{ longStayPrices[0] ? longStayPrices[0].pricePerMonth : "" }} per month
        </div>
      </div>
    </div>


    <div class="rooms-pricing-details__book-section" :class="{ 'rooms-pricing-details__book-section': longStayFlag }">
      <div v-if="bookingType==='longStay' && longStayPrices.length" class="rooms-pricing-details__book-section--price ">
        <!-- <div v-if="longStayPriceText" class="rooms-pricing-details__price-free-text" v-html="longStayPriceText" />
        <div v-if="!longStayPriceText" class="rooms-pricing-details__price-free-text">
          &pound;{{ longStayPrices[0] ? longStayPrices[0].pricePerWeek : "" }} per week
          /
          {{ longStayPrices[0] ? longStayPrices[0].pricePerMonth : "" }} per month
        </div> -->
      </div>
      <div v-if="bookingType==='shortStay'" class="rooms-pricing-details__book-section--price">
        <div class="rooms-pricing-details__price-free-text shortstay">
          {{ shortStayPriceText || '&nbsp;' }}
        </div>
      </div>


      <div class="rooms-pricing-details__book-section--button">
        <div v-if="bookingType==='longStay'" class="rooms-pricing-details__book-button">
          <button v-if="type.length >0" class="btn--small" aria-label="book-to-stay" @click="collectData(); openStay()">
            {{ longStayButtonCtaDisplay }}
          </button>
        </div>
        <div v-if="bookingType==='shortStay'" class="rooms-pricing-details__book-button">
          <button v-if="type.length > 0" class="btn--small" aria-label="book-to-stay" @click="collectData(); openStay()">
            {{ shortStayButtonCtaDisplay }}
          </button>
        </div>
        <div class="rooms-pricing-details__cta">
          <div class="btn btn--text" aria-label="view-gallery" @click="viewGallery(contentCodename)">
            More Details >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBookingStayPath } from '~/utils/booking';
import pascalCase from 'pascal-case';
import { forceObject } from '~/utils/processor';
import { clickedCta } from '~/utils/gtm-events.js';
import { TABNAME_LONG_STAY, TABNAME_SHORT_STAY } from '~/utils/constants';

export default {
  props: {
    disableAccordionLG: { type: Boolean, default: true },
    currency: { type: String, default: '£' },
    title: { type: String, default: '', required: true },
    contentCodename: { type: String, default: '', required: true },
    bodyContent: { type: String, default: '' },
    billsIncludedText: { type: String, default: 'All bills included' },
    ctaLinkText: { type: String, default: 'Book now' },
    // eslint-disable-next-line vue/require-default-prop
    longStayCtaLink: { type: String, required: false },
    // eslint-disable-next-line vue/require-default-prop
    shortStayCtaLink: { type: String, required: false },
    shortStayTabText: { type: String, default: 'Drop by for a night', required: false },
    longStayTabText: { type: String, default: 'Settle in for longer', required: false },
    viewDetailsText: { type: String, default: 'View Details' },
    hideDetailsText: { type: String, default: 'Hide Details' },
    bookingType: { type: String, default: 'longStay' },
    openGallery: { type: Function, default() {} },
    billsIncluded: {
      type: Array,
      required: true,
      default() {
        return [
          {
            codename: 'yes',
          },
        ];
      },
    },

    type: {
      type: Array,
      default() {
        return [];
      },
    },
    facilities: {
      type: Array,
      default() {
        return [];
      },
    },
    longStayTitle: { type: String, default: '' },
    longStayPrices: {
      type: Array,
      default() {
        return [];
      },
    },
    longStayMonthSuffix: { type: String, default: 'pm' },
    longStayWeekSuffix: { type: String, default: 'pw' },
    shortStayTitle: { type: String, default: 'Short Stay' },
    shortStayDuration: { type: String, default: '' },
    shortStayPrice: { type: String, default: '' },
    shortStayPriceText: { type: String, default: '' },
    longStayPriceText: { type: String, default: '' },
    shortStayPrefix: { type: String, default: 'Starting from' },
    shortStaySuffix: { type: String, default: 'pn' },
    callToActionText: { type: String, default: '', required: false },
    externalLink: { type: String, default: '', required: false },
    shortStayDescription: { type: String, default: '' },
    longStayDescription: { type: String, default: '' },
    maximumCapacity: { type: Number, required: false, default: null },
    shortStayButtonCta: { type: String, required: false, default: 'Book Now' },
    longStayButtonCta: { type: String, required: false, default: 'Book Now' },
    link: {
      type: Object,
      default() {
        return {
          slug: '',
        };
      },
    },
  },
  data() {
    return {
      detailsOpen: true,
      longStayFlag: false,
      shortStayFlag: false,
    };
  },
  computed: {
    dynamicViewDetailsText() {
      if (!this.detailsOpen) {
        return this.viewDetailsText;
      } else {
        return this.hideDetailsText;
      }
    },
    billsIncludedCheck() {
      if (this.billsIncluded.length > 0) {
        const billsIncludedObj = forceObject(this.billsIncluded);

        if (billsIncludedObj.codename === 'yes') {
          return true;
        }
      }

      return false;
    },
    typeTitle() {
      const typeObj = forceObject(this.type);

      return typeObj.name;
    },
    typeCode() {
      const typeObj = forceObject(this.type);

      return typeObj.codename;
    },
    longStayButtonCtaDisplay() {
      return this.longStayButtonCta? this.longStayButtonCta : this.ctaLinkText;
    },
    shortStayButtonCtaDisplay() {
      return this.shortStayButtonCta? this.shortStayButtonCta : this.ctaLinkText;
    },
  },
  created() {
    switch (this.typeCode) {
      case 'longStay': {
        this.showLong();
        break;
      }
      case 'shortStay': {
        this.showShort();
        break;
      }
      case 'shortLongStay': {
        this.showLong();
        break;
      }
      default: {
        this.showLong();
        break;
      }
    }
  },
  methods: {
    selectTabName() {

      return (this.bookingType==='longStay') ? TABNAME_LONG_STAY :TABNAME_SHORT_STAY;
    },
    openStay() {

      const { location } = this.getLocation();

      if (!!this.shortStayCtaLink && this.shortStayCtaLink.length > 0) {
        window.location = this.shortStayCtaLink;
      } else if (!!this.longStayCtaLink && this.longStayCtaLink.length > 0) {
        window.location = this.longStayCtaLink;
      } else {

        this.$modal.show('booking', {
          location,
          bookingType: this.selectTabName(),
        });
      }


    },

    change(value) {
      this.detailsOpen = value;
    },
    getIcon(icon) {
      const { codename } = forceObject(icon);
      return pascalCase(codename.toLowerCase());
    },
    getDurationTitle(duration) {
      const { name } = forceObject(duration);
      return name;
    },
    showLong() {
      this.longStayFlag = true;
      this.shortStayFlag = false;
    },
    showShort() {
      this.longStayFlag = false;
      this.shortStayFlag = true;
    },
    getLocation() {
      let location;
      let path;
      if (this.longStayCtaLink === undefined || this.longStayCtaLink === null || this.longStayCtaLink === '') {
        const parent = this.$parent.$parent.$parent.$parent;
        path = getBookingStayPath(parent.$attrs.slug);
        location = parent.title;
      } else {
        const longStayCtaLinkLowered = this.longStayCtaLink.toLowerCase();
        if (!longStayCtaLinkLowered.startsWith('http')) {
          path = `/`+longStayCtaLinkLowered;
        }
      }

      return { location, path };
    },
    collectData() {

      const { location, path } = this.getLocation();
      clickedCta(this.$gtm, this.ctaLinkText, location, this.title, path);
    },
    viewGallery(contentCodename) {
      if (typeof this.openGallery !== 'undefined') {
        this.openGallery(contentCodename, this.bookingType, this.getLocation());
      }
    },
  },
};
</script>
<style lang="scss">
@import '~/assets/scss/atomic/components/_rooms-pricing-details.scss';
</style>
